import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

export default function HamarosaanPage({ title = 'Hamarosan', description = 'Ez a funkció fejlesztés alatt áll. Rövidesen elérhető lesz!' }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="w-16 h-16 rounded-2xl bg-[#e31937]/10 border border-[#e31937]/20 flex items-center justify-center mb-6">
        <Zap size={28} className="text-[#e31937]" />
      </div>
      <h1 className="text-3xl font-black text-white mb-3">{title}</h1>
      <p className="text-[#9ca3af] text-base mb-8 max-w-md leading-relaxed">{description}</p>
      <Link
        to="/"
        className="bg-[#e31937] hover:bg-[#cc1530] text-white font-bold px-6 py-3 rounded-xl transition-colors text-sm"
      >
        ← Vissza a főoldalra
      </Link>
    </div>
  );
}
